import { render, staticRenderFns } from "./dynamicComponent.vue?vue&type=template&id=1f973d2d"
import script from "./dynamicComponent.vue?vue&type=script&lang=js"
export * from "./dynamicComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports